module.exports = __webpack_public_path__ + "img/icon_user_Gray.773cdf60.svg";